import { render } from "./AppTop.vue?vue&type=template&id=528ba0fe"
import script from "./AppTop.vue?vue&type=script&lang=js"
export * from "./AppTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v1/AppTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "528ba0fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('528ba0fe', __exports__)) {
    api.reload('528ba0fe', __exports__)
  }
  
  module.hot.accept("./AppTop.vue?vue&type=template&id=528ba0fe", () => {
    api.rerender('528ba0fe', render)
  })

}


export default __exports__